import {Button, Group, Modal, Stack, Text} from '@mantine/core';
import React from 'react';

export interface AntibodyComponentMigrationReviewModalProps {
  onClose: () => void;
  onPublish: () => void | Promise<void>;
  isPublishing?: boolean;
}

export function AntibodyComponentMigrationReviewModal({
  onClose,
  onPublish,
  isPublishing = false,
}: AntibodyComponentMigrationReviewModalProps): JSX.Element {
  return (
    <Modal
      title="Review & publish"
      opened={true}
      onClose={onClose}
      size="lg"
      padding="lg"
      closeOnClickOutside={!isPublishing}
      closeOnEscape={!isPublishing}
      withCloseButton={!isPublishing}
      closeButtonProps={{'aria-label': 'Close'}}
    >
      <Stack spacing="lg">
        <Text>Review changes before publishing.</Text>
        <Group position="right">
          <Button variant="secondary" onClick={onClose} disabled={isPublishing}>
            Cancel
          </Button>
          <Button onClick={onPublish} loading={isPublishing} data-autofocus={true}>
            Publish
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
